import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  domainCutover,
  regionConfig,
  alternateBaseUrl,
  X_DEFAULT_BASE_URL,
  isUK,
} from '@/config/region';

const HREFLANG_SELF = isUK ? 'en-GB' : 'en-US';
const HREFLANG_ALTERNATE = isUK ? 'en-US' : 'en-GB';

const setAlternateLink = (hreflang: string, href: string) => {
  let link = document.head.querySelector<HTMLLinkElement>(
    `link[rel="alternate"][hreflang="${hreflang}"]`
  );
  if (!link) {
    link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = hreflang;
    document.head.appendChild(link);
  }
  link.href = href;
};

/**
 * Emits rel="alternate" hreflang link tags pairing the UK (storily.io) and
 * US (us.storily.io) sites page-for-page. Both builds register identical
 * routes, so the alternate is always the same pathname on the other base URL.
 *
 * Inert until VITE_DOMAIN_CUTOVER is enabled — before launch the alternate
 * domains don't serve the right content yet, and dangling hreflang would
 * hurt rather than help. The tags land in the prerendered HTML because
 * scripts/prerender.ts captures the fully rendered <head>.
 */
const HreflangTags = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!domainCutover) return;
    setAlternateLink(HREFLANG_SELF, `${regionConfig.baseUrl}${pathname}`);
    setAlternateLink(HREFLANG_ALTERNATE, `${alternateBaseUrl}${pathname}`);
    setAlternateLink('x-default', `${X_DEFAULT_BASE_URL}${pathname}`);
  }, [pathname]);

  return null;
};

export default HreflangTags;
